import $ from 'jquery';
import thirdPartyCookies from '../utils/third_party_cookie';

export default function () {
    if (document.location.href.indexOf('take-me-out-of-the-new-fc') !== -1) {
        $('.public-beta-optout-shade, .public-beta-optout-overlay').slideDown(800);
    }

    $('.publicBetaOptOut').on('click', function () {
        $('html, body').animate({ scrollTop: 0 }, 'fast', function () {
            $('.public-beta-optout-shade, .public-beta-optout-overlay').slideDown(800);
        });
    });

    // Opt out of redesign, just set cookie for theme_ver to 1 in the base path.
    $('.beta-optout-button-ok').on('click', function () {
        $('.spinner ').fadeIn();
        $.when(
          $.ajax({type: 'GET', dataType: 'jsonp', url: '//m.fastcompany.com/api/v3/beta-opt-out?callback=?'}, function () {}),
          $.ajax({type: 'GET', dataType: 'jsonp', url: '//m.fastcodesign.com/api/v3/beta-opt-out?callback=?'}, function () {}),
          $.ajax({type: 'GET', dataType: 'jsonp', url: '//m.fastcocreate.com/api/v3/beta-opt-out?callback=?'}, function () {}),
          $.ajax({type: 'GET', dataType: 'jsonp', url: '//m.fastcoexist.com/api/v3/beta-opt-out?callback=?'}, function () {}),
          $.ajax({type: 'GET', dataType: 'jsonp', url: '//m.fastcolabs.com/api/v3/beta-opt-out?callback=?'}, function () {}),
          $.ajax({type: 'GET', dataType: 'jsonp', url: '//www.fastcompany.com/api/v3/beta-opt-out?callback=?'}, function () {}),
          $.ajax({type: 'GET', dataType: 'jsonp', url: '//www.fastcodesign.com/api/v3/beta-opt-out?callback=?'}, function () {}),
          $.ajax({type: 'GET', dataType: 'jsonp', url: '//www.fastcoexist.com/api/v3/beta-opt-out?callback=?'}, function () {}),
          $.ajax({type: 'GET', dataType: 'jsonp', url: '//www.fastcocreate.com/api/v3/beta-opt-out?callback=?'}, function () {}),
          $.ajax({type: 'GET', dataType: 'jsonp', url: '//www.fastcolabs.com/api/v3/beta-opt-out?callback=?'}, function () {})
        ).then(function () {
            window.ga('send', 'event', 'User', 'Redesign: Opt Out', null, null, {nonInteraction: 1});
            window.ga('rollup.send', 'event', 'User', 'Redesign: Opt Out', null, null, {nonInteraction: 1});
            thirdPartyCookies('removeCookies', [{name: 'theme_ver'}]);
            window.location.reload();
        });
    });

    // Close Modal
    $('.public-beta-optout-shade, .beta-optout-button-cancel').on('click', function () {
        $('.public-beta-optout-shade, .public-beta-optout-overlay').slideUp(800);
    });
}
